import { render, staticRenderFns } from "./CircleIcon.vue?vue&type=template&id=07d97fcf&scoped=true&"
import script from "./CircleIcon.vue?vue&type=script&lang=ts&"
export * from "./CircleIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CircleIcon.vue?vue&type=style&index=0&id=07d97fcf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d97fcf",
  null
  
)

export default component.exports